import { AccordionItem, Section, SectionHeader } from '@/components/ui/primitives';
import { useFaq } from '@/lib/queries';
import { useI18n } from '@/lib/i18n';

export function FaqSection({
  category,
  limit,
}: {
  category?: string | undefined;
  limit?: number | undefined;
}): React.JSX.Element {
  const { t } = useI18n();
  const { data, isPending } = useFaq(category);
  const items = limit ? data?.slice(0, limit) : data;

  return (
    <Section subtle>
      <SectionHeader overline={t('faq.overline')} title={t('faq.title')} />

      <div className="mt-10">
        {isPending
          ? Array.from({ length: 5 }, (_, i) => (
              <div key={i} className="h-20 animate-pulse border-b border-border-default" />
            ))
          : items?.map((item, index) => (
              <AccordionItem
                key={item.id}
                question={item.question}
                answer={item.answer}
                defaultOpen={index === 0}
              />
            ))}
      </div>
    </Section>
  );
}
